// extracted by mini-css-extract-plugin
export default {"root":"qEhgJEpm","middle":"GjxPnwZR","big":"HRLrnZvQ","adaptive":"ebO2WJkv","svg":"lbK6aMGA","img":"aiNWbNvj","clickable":"hqg1cKl7"};